import React from 'react';
import { Container, Box, Typography } from '@mui/material';

import how1_m from '../../../ui-utils/latestPics/how1.svg';
import how2_m from '../../../ui-utils/latestPics/how3.svg';
import how3_m from '../../../ui-utils/latestPics/how2.svg';
import how4_m from '../../../ui-utils/latestPics/how4.svg';
import arr_down from '../../../ui-utils/latestPics/arr_dwn_2.svg';
import { useLanguage } from "../../../Context/LangContext";
const MobileView = () => {
  const { language } = useLanguage();
    const headingTranslations = {
      en: "How it works",
      "hi": "कैसे काम करता है",
      "kn": "ಹೇಗೆ ಕೆಲಸ",
      "ma": "कसे कार्य",
      "gu": "કેમ કાર્ય કરે"
    };
  return (
    <>
      {/* Title Section */}
      <Box
        sx={{
          width: '100%',
          py: { xs: 2, md: 6 },
          display: 'flex',
          justifyContent: 'center',
          background:"#FFF6EE"
        }}
      >
        <h1
          variant="h4"
          sx={{
            color: "#3E3E3E",
            fontSize: { xs: 'calc(24px + var(--font-delta))', md: 'calc(40px + var(--font-delta))' },
            fontFamily: 'Inter500',
            textAlign: 'center',
          }}
        >
          {headingTranslations[language] || headingTranslations.en}
        </h1>
      </Box>

      {/* Steps Section */}
      <Box sx={{ width: '100%', background: "#FFF6EE" }}>
        <Container maxWidth="md">
          {/* Step 1 */}
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 3 }}>
            <Box
              component="img"
              src={how1_m}
              alt="Step 1"
              sx={{ width: { xs: '80%', md: '50%' }, height: 'auto' }}
            />
          </Box>

          {/* Arrow */}
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
            <Box component="img" src={arr_down} alt="Arrow down" />
          </Box>

          {/* Step 2 */}
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
            <Box
              component="img"
              src={how2_m}
              alt="Step 2"
              sx={{ width: { xs: '80%', md: '50%' }, height: 'auto' }}
            />
          </Box>

          {/* Arrow */}
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
            <Box component="img" src={arr_down} alt="Arrow down" />
          </Box>

          {/* Step 3 */}
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
            <Box
              component="img"
              src={how3_m}
              alt="Step 3"
              sx={{ width: { xs: '80%', md: '50%' }, height: 'auto' }}
            />
          </Box>

          {/* Arrow */}
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
            <Box component="img" src={arr_down} alt="Arrow down" />
          </Box>

          {/* Step 4 */}
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2, pb: 4 }}>
            <Box
              component="img"
              src={how4_m}
              alt="Step 4"
              sx={{ width: { xs: '80%', md: '50%' }, height: 'auto' }}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default MobileView;
